import { Breadcrumb,Form,Checkbox,Button,Select,Table,Input, message} from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link,useParams,useNavigate } from 'react-router-dom';
import { SERVER_ADDRESS } from '../../Config/Config';

const EditAdmin = () => {
    const [form] = Form.useForm();
    const {id} = useParams();
    const [user,setUser] = useState({});
    const navigate = useNavigate();
    const [privileges,setPrivileges] = useState({
        users:{
            verification:false,
            create:false,
            edit:false,
            delete:false,
            subscription:false,
            fullAccess:false
        },
    });

    const fetchUser = async()=>{
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/getAdmin`,{
                id
            });
            const data = response.data.data;
            setUser(data);
            
            form.setFieldsValue({
                name:data.name,
                email:data.email,
                role:data.role
            });

            setPrivileges({
                users: {
                    verification: data.privelege.includes('verification'),
                    create: data.privelege.includes('create'),
                    edit: data.privelege.includes('edit'),
                    delete: data.privelege.includes('delete'),
                    subscription:data.privelege.includes('subscription'),
                    fullAccess:
                        data.privelege.includes('verification') &&
                        data.privelege.includes('create') &&
                        data.privelege.includes('edit') &&
                        data.privelege.includes('delete') &&
                        data.privelege.includes('subscription'),
                },
            });
        } catch (error) {
            console.log(error);
            message.error({content:"Error on fetching admin"})
        }
    };

    const handlePrivilegeChange = (module,privilege)=>{
        setPrivileges((prev)=>{
            const newPrivileges = {...prev};
            if(privilege === 'fullAccess'){
                const isChecked = !newPrivileges[module].fullAccess;
                newPrivileges[module] = {
                    verification:isChecked,
                    create:isChecked,
                    edit:isChecked,
                    delete:isChecked,
                    subscription:isChecked,
                    fullAccess:isChecked
                };
            }
            else{
                newPrivileges[module][privilege]=!newPrivileges[module][privilege];
                if (!newPrivileges[module][privilege]) {
                    newPrivileges[module].fullAccess = false;
                }
                const allChecked = ['verification', 'create', 'edit', 'delete','subscription'].every(
                    (key) => newPrivileges[module][key]
                );
                newPrivileges[module].fullAccess = allChecked;
            }
            return { ...newPrivileges };
        })
    }
    const roleOptions = [
        { value: 'Admin', label: 'Admin' },
        { value: 'Sub-Admin', label: 'Sub-Admin' },
    ];

    const columns = [
        {
            title: 'Module',
            dataIndex: 'module',
            render: (text) => <strong>{text}</strong>,
        },
        {
            title: 'Verification',
            dataIndex: 'verification',
            render: (_, record) => (
                <Checkbox
                    checked={privileges[record.module].verification}
                    onChange={() => handlePrivilegeChange(record.module, 'verification')}
                />
            ),
        },
        {
            title: 'Create',
            dataIndex: 'create',
            render: (_, record) => (
                <Checkbox
                    checked={privileges[record.module].create}
                    onChange={() => handlePrivilegeChange(record.module, 'create')}
                />
            ),
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            render: (_, record) => (
                <Checkbox
                    checked={privileges[record.module].edit}
                    onChange={() => handlePrivilegeChange(record.module, 'edit')}
                />
            ),
        },
        {
            title: 'Delete',
            dataIndex: 'delete',
            render: (_, record) => (
                <Checkbox
                    checked={privileges[record.module].delete}
                    onChange={() => handlePrivilegeChange(record.module, 'delete')}
                />
            ),
        },
        {
            title: 'Subscription',
            dataIndex: 'subscription',
            render: (_, record) => (
                <Checkbox
                    checked={privileges[record.module].subscription}
                    onChange={() => handlePrivilegeChange(record.module, 'subscription')}
                />
            ),
        },
        {
            title: 'Full Access',
            dataIndex: 'fullAccess',
            render: (_, record) => (
                <Checkbox
                    checked={privileges[record.module].fullAccess}
                    onChange={() => handlePrivilegeChange(record.module, 'fullAccess')}
                />
            ),
        },
    ];

    const data = [{ key: '1', module: 'users' }];

    useEffect(()=>{
        fetchUser();
    },[])

    const getPrivilegesArray = () => {
        const modulePrivileges = privileges.users;
        return Object.keys(modulePrivileges).filter((key) => modulePrivileges[key] && key !== 'fullAccess');
    };

    const handleSubmit = async(values)=>{
         const priveleges = getPrivilegesArray()
                if(priveleges.length === 0){
                    message.warning({content:"Kindly Check priveleges"})
                    return;
                }
        const payload ={
            id,
            ...values,
            privileges:getPrivilegesArray()
        }
        console.log(payload)
        try{
            const response = await axios.post(`${SERVER_ADDRESS}/api/editAdmin`,{payload})
            if(response.status === 200){
                navigate('/adminList');
            }
        }
        catch(error){
            console.log(error)
            message.error({content:"Error on updating admin"})
        }
    }

    const breadcrumbItems = [
        {
            path: "/dashboard",
            title: "Home",
        },
        {
            path: "/adminList",
            title: "Admin List",
        },
    ];
  return (
    <>
    <div style={{marginTop:"4rem"}} >
        <div className='d-flex flex-row justify-content-between' >
            <h3>Edit {user.name} Details</h3>
            <Breadcrumb>
                {breadcrumbItems.map((item,index)=>(
                    <Breadcrumb.Item key={index} >
                        <Link to={item.path}>{item.title}</Link>
                    </Breadcrumb.Item>
                ))}
            </Breadcrumb>
        </div>
        <div style={{ marginTop: '3rem',backgroundColor:"white",padding:'3rem' }}>
                <Form form={form} name="editAdmin" onFinish={handleSubmit} style={{ width: '50%' }}>
                    <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Enter name' }]}>
                        <Input placeholder="Enter the Name" />
                    </Form.Item>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { required: true, message: 'Enter Email' },
                            { type: 'email', message: 'Enter valid Email' },
                        ]}
                    >
                        <Input placeholder="Enter the Email" />
                    </Form.Item>
                    <Form.Item
                        label="Role"
                        name="role"
                        rules={[{ required: true, message: 'Select Role' }]}
                    >
                        <Select placeholder="Select Role" options={roleOptions} />
                    </Form.Item>
                    
                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[{ required: true, message: 'Enter Password' }]}
                    >
                        <Input.Password placeholder="Enter the Password" />
                    </Form.Item>
                    
                    <div style={{ marginLeft: '5rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Table pagination={false} columns={columns} dataSource={data} style={{ width: '100%' }} />
                    </div>
                    <Form.Item style={{ textAlign: 'center', marginTop: '2rem' }}>
                        <Button type="primary" htmlType="submit">
                            {id ? 'Update' : 'Submit'}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
    </div>
    </>
  )
}

export default EditAdmin